import { request } from '../../config/helpers/axios-instance'
import { toast } from 'react-toastify'

// LeadSquared Users.Get rows spell the id inconsistently across responses.
// Lives here rather than in index.jsx so both the LSQ tab and the Lead Transfer
// tab can import it without the page and its child importing each other.
export const lsqRowId = (u) => u.ID ?? u.Id ?? u.UserId

export const flipSupportActiveUser = async (userId) => {
    try {
        const response = await request({
            url: `userDetail/admin/flipSupportActiveStatus/${userId}`,
            method: 'PUT',
        })
        if (response.data && response.data.success) {
            toast.success("Support active user flipped successfully.")
            return response.data.data;
        }
        toast.warn("Couldn't flip support active user.")
        return null;
    } catch (error) {
        toast.warn("Couldn't flip support active user.")
        return null;
    }
}

export const toggleLsqUserCheckedIn = async (userId) => {
    try {
        const response = await request({
            url: `lsq/admin/users/toggle-checked-in`,
            method: "PUT",
            data: { userId },
        })
        if (response.data && response.data.success) {
            toast.success("LeadSquared check-in status updated.")
            return response.data.data;
        }
        const err = response.data?.error
        toast.warn(typeof err === "string" && err ? err : "Couldn't update LeadSquared check-in status.")
        return null;
    } catch (error) {
        toast.warn("Couldn't update LeadSquared check-in status.")
        return null;
    }
}

export const distributeLead = async (source, targets, statuses = null) => {
    try {
        const response = await request({
            url: `requestCallback/admin/reassign`,
            method: 'POST',
            data: {
                source,
                targets,
                statuses
            }
        })
        if (response.data && response.data.success) {
            toast.success("Lead distributed successfully.")
            return response.data.data;
        }
        toast.warn("Couldn't distribute lead.")
        return null;
    } catch (error) {
        toast.warn("Couldn't distribute lead.")
        return null;
    }
}